import { httpGet, httpPost, httpPut } from '@/tool/request/index';
// 引入 getUserId
import { useUserStore } from '@/stores/user';
export interface uploadFiles {
  accessUrl?: string; // 附件访问地址
  filePath?: string; // 附件路径
  name?: string; // 附件名称
  status?: string; // 附件状态
  taroFilePath?: string; // taro文件路径
  type?: string; // 附件类型
  url?: string; // 附件URL
}

export interface handoverItems {
  id?: string; // 接收人ID
  handoverId?: string; // 交接单ID
  handoverItem?: string; // 交接内容名称
  isCompleted?: boolean; // 是否完成
  uploadFiles?: uploadFiles[]; // 附件
}

// 保存数据
export interface handoverObj {
  id?: string;
  baseId?: any;
  receiverId?: string; // 接收人
  receiverName?: string; // 接收人姓名
  handoverTime?: Date | string; // 交接时间
  handoverItems?: handoverItems[]; // 交接内容列表
  submitId?: string; // 提交人ID
  submitUser?: string; // 提交人姓名
  status?: string; // 状态 0: 待接收 1: 已接收
  handoverRecords?: any[]; // 系统列表
}

// 保存交接单
export const saveHandover = async (data: handoverObj) => {
  return await httpPost<API.RootResponse>('/handover/')({
    data,
  });
};

// 更新交接单
export const updateHandover = async (
  data: handoverObj,
  options?: {
    header?: { [key: string]: string };
    params?: { [key: string]: string };
  }
) => {
  return await httpPut<API.RootResponse>(`/handover/${data.id}`)({
    data,
    isUrlQs: true,
    ...options,
  });
};

// 获取交接班列表
export const getHandoverData = async (data: { type: '交班' | '接班' }) => {
  const userStore = useUserStore();
  return await httpGet<API.RootResponse>(
    `/handover/${userStore?.getUserId}/data`
  )({
    data,
  });
};

// 获取交接班详情
export const getHandoverDetail = async (handoverId: string) => {
  return await httpGet<API.RootResponse>(`/handover/${handoverId}`)();
};

// 保存交接单 - 审核
export const saveHandoverAudit = async (data: handoverObj) => {
  return await httpPost<API.RootResponse>('/handover/')({
    data,
  });
};

// 更新交接单 - 审核
export const updateHandoverAudit = async (data: handoverObj) => {
  return await httpPut<API.RootResponse>(`/handover/${data.id}`)({
    data,
  });
};

// 获取交接班 - 审核列表
export const getHandoverAuditList = async (data: {
  type: '待审核' | '已审核' | '审核' | '初审' | '复审';
}) => {
  const userStore = useUserStore();
  return await httpGet<API.RootResponse>(
    `/handover/${userStore?.getUserId}/data`
  )({
    data,
  });
};

// 获取交接班 - 审核详情
export const getHandoverAuditDetail = async (handoverId: string) => {
  return await httpGet<API.RootResponse>(`/handover/${handoverId}`)();
};
